// src/shared/ui/Spinner.jsx
//
// Promoted from components/LoadingSpinner.jsx (kept as a thin wrapper for
// existing imports) and generalizes the various inline
// `animate-spin`+border-only spinner markup scattered across modules.
//
// Usage:
//   <Spinner />
//   <Spinner size="lg" className="text-white" />

import PropTypes from "prop-types";

const SIZE_CLASSES = {
  sm: "w-4 h-4 border-2",
  md: "w-8 h-8 border-2",
  lg: "w-12 h-12 border-[3px]",
};

export default function Spinner({ size = "md", className = "" }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={[
        "inline-block rounded-full border-line border-t-brand-600 animate-spin",
        SIZE_CLASSES[size] ?? SIZE_CLASSES.md,
        className,
      ].filter(Boolean).join(" ")}
    />
  );
}

Spinner.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  className: PropTypes.string,
};
